import { useQuery } from '@tanstack/react-query';
import { authorizeGoogle } from 'api/services';
import { BrokenLinkIcon } from 'library/icons';
import { CircularProgress } from 'library/loaders';
import { IllustrationView } from 'modules/shared/features/illustration';
import { Link, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const constructGoogleRedirectUrl = () => {
    return import.meta.env.VITE_APP_AUTH_REDIRECT_URL + '/google-authorization';
};

const GoogleIllustration = () => {
    return (
        <div className="flex items-center gap-5">
            <img className="h-10" src="/logos/logo.png" alt="progressCenter" />
            <BrokenLinkIcon />
            <img className="h-10" src="/plugins-images/google.svg" alt="Google" />
        </div>
    );
};

const GoogleAuthorizationPage = () => {
    const [searchParams] = useSearchParams();

    const code = searchParams.get('code');
    const state = searchParams.get('state');

    const redirectUri = constructGoogleRedirectUrl();

    const { pluginId, url } = JSON.parse(decodeURIComponent(state));

    const googleQuery = useQuery(
        ['google-authorize', code, redirectUri],
        () => authorizeGoogle({ code, redirectUri }),
        {
            retry: 0,
        }
    );

    if (googleQuery.isSuccess) {
        toast.success('Google account linked successfully.');

        window.location.replace(`${url}/plugins/${pluginId}/google`);
    }

    if (googleQuery.isLoading) {
        return (
            <section>
                <div className="fixed top-0 left-0 flex flex-col items-center justify-center h-screen w-full bg-card-color">
                    <div className="flex items-center justify-center w-14 h-14 rounded-lg text-primary ">
                        <CircularProgress size={32} />
                    </div>
                </div>
            </section>
        );
    }

    if (googleQuery.error) {
        return (
            <IllustrationView
                className="justify-center h-screen"
                illustration={<GoogleIllustration />}
                title="Google Authorization Failed"
                message={
                    <>
                        {/* We couldn’t connect to your Google account. Please check your credentials or try again.
                         */}
                        {(googleQuery.error as any).data.message}
                        <div className="mt-2">
                            <Link to={`${url}`} replace className="text-primary font-medium cursor-pointer">
                                Back to home
                            </Link>
                        </div>
                    </>
                }
            />
        );
    }
};

export default GoogleAuthorizationPage;
